import { haveGtmAndGaLoaded } from './AnalyticsHelpers'

// Anything pushed before this is true is dropped, so tracking that fires on page load waits for it.
export function canPushToDataLayer () {
  return process.env.NODE_ENV !== 'production' || haveGtmAndGaLoaded()
}

export function pushToDataLayer (eventName, customEventProperties) {
  if (!canPushToDataLayer()) return

  const simpleEvent = { event: eventName }

  if (customEventProperties) {
    logCustomEvent(eventName, customEventProperties)
    // GTM's data layer merges pushes recursively, so amplitude properties from an
    // earlier event (e.g. a carousel "Viewed"'s listing ids) bleed into later ones
    // unless we null them first. This reset push carries no `event`, so it triggers
    // no tags — it only clears the stale keys before the real push below. Scoped to
    // amplitude pushes so non-amplitude (snowplow) events aren't needlessly shifted.
    if (isAmplitudePush(customEventProperties)) {
      window.dataLayer.push({ amplitude_event_name: undefined, amplitude_event_properties: undefined })
    }
    window.dataLayer.push({
      ...simpleEvent,
      ...customEventProperties
    })
    return
  }

  logSimpleEvent(eventName)
  window.dataLayer.push(simpleEvent)
}

function isAmplitudePush (customEventProperties) {
  return 'amplitude_event_name' in customEventProperties || 'amplitude_event_properties' in customEventProperties
}

function logSimpleEvent (eventName) {
  if (jsEventTrackingIsEnabled()) {
    console.log('simpleEvent:', eventName)
  }
}

function logCustomEvent (eventName, customEventProperties) {
  if (jsEventTrackingIsEnabled()) {
    console.log('customEvent: ', eventName, '\nProperties: ', JSON.stringify(customEventProperties, null, 2))
  }
}

function jsEventTrackingIsEnabled () {
  const jsEventLogsFlipperValueEl = document.getElementById('vjs-js-event-tracking-logs')
  if (!jsEventLogsFlipperValueEl) return false
  return JSON.parse(jsEventLogsFlipperValueEl.value)
}
